import { gql } from "apollo-angular";
import { DocumentNode } from "graphql";

const GET_STORE_CONFIGURATION: DocumentNode = gql`

  query initApp($storeId: String!){

  ConfigurationStore(appId:$storeId){
    StoreName,
    MeasurementUnitsDecimalSeparator,
    MeasurementUnitsDecimalPlaces,
    MeasurementUnitsName,
    CurrencyDecimalSeparator,
    CurrencyDecimalPlaces,
    Symbol,
    LengthUnitsDecimalSeparator,
    LengthUnitsDecimalPlaces,
    StoreImage,
    VolumenIdentifier,
    MesuIdentifier,
    languageIdentifier,
    DateFormatIdentifier,
    CurrenceIdentifier,
    VolumeUnitsName,
    StoreEmail
    StorePhoneNumber
    Content
    ParameterOptionId
    LanguageTemplateAdmin,
    LanguageTemplateStore,
  },
 StyleType(appId:$storeId) {
    StyleTypeName,
    StyleValue,
    StyleTypeDescription
  }


}
`;

export { GET_STORE_CONFIGURATION };

export const GET_STORE_INFO:DocumentNode=gql`
query getStoreInfo($storeID: UUID!){
  getStoreInfo(storeID: $storeID) {
    callingCode
    dateFormat
    storeEmail
    storeLogo
    storeName
    storePhone
    termsAndConditions
  }
}`
